import { Link } from 'react-router-dom';
import { KaneaLogo } from '../../components/Common/KaneaLogo';
import usePageTitle from '../../hooks/usePageTitle';
import { useAuth } from '../../context/AuthContext';

// Destinations proposées plutôt qu'un seul lien : un lien d'e-mail périmé ne doit pas être un cul-de-sac.
const DESTINATIONS_CONNECTE = [
  { to: '/dashboard', label: 'Tableau de bord' },
  { to: '/cotations', label: 'Marché des actions' },
  { to: '/my-assets', label: 'Mon portefeuille' },
  { to: '/chat', label: 'Discuter avec Nia' },
];
const DESTINATIONS_VISITEUR = [
  { to: '/home', label: "Page d'accueil" },
  { to: '/outils', label: 'Outils gratuits' },
  { to: '/help', label: "Centre d'aide" },
  { to: '/login', label: 'Se connecter' },
];

const NotFoundScreen: React.FC = () => {
  usePageTitle('Page introuvable');
  const { isAuthenticated } = useAuth();
  const destinations = isAuthenticated ? DESTINATIONS_CONNECTE : DESTINATIONS_VISITEUR;

  return (
    <div className='full-height flex flex-column flex-center' style={{ padding: '0 16px', textAlign: 'center' }}>
      <KaneaLogo variant='horizontal' height={48} markColor='#6C3FC4' title='KaneaBourse' />
      <h1 className='title-404'>404</h1>
      <p className='paragraph-404'>
        Cette page n'existe pas ou a été déplacée. Voici où vous pouvez aller :
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center', maxWidth: 520 }}>
        {destinations.map((d, i) => (
          <Link
            key={d.to}
            to={d.to}
            className={`button button-medium ${i === 0 ? 'button-purple' : 'button-white'}`}
            style={{ minHeight: 44, display: 'inline-flex', alignItems: 'center' }}
          >
            {d.label}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NotFoundScreen;
